"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDepositInstruction = void 0;
const splToken = __importStar(require("@solana/spl-token"));
const beet = __importStar(require("@metaplex-foundation/beet"));
const web3 = __importStar(require("@solana/web3.js"));
const depositStruct = new beet.BeetArgsStruct([
    ['instructionDiscriminator', beet.uniformFixedSizeArray(beet.u8, 8)],
    ['escrowPaymentBump', beet.u8],
    ['amount', beet.u64],
], 'DepositInstructionArgs');
const depositInstructionDiscriminator = [242, 35, 198, 137, 82, 225, 242, 182];
function createDepositInstruction(accounts, args) {
    const { wallet, paymentAccount, transferAuthority, escrowPaymentAccount, treasuryMint, authority, auctionHouse, auctionHouseFeeAccount, } = accounts;
    const [data] = depositStruct.serialize({
        instructionDiscriminator: depositInstructionDiscriminator,
        ...args,
    });
    const keys = [
        {
            pubkey: wallet,
            isWritable: false,
            isSigner: true,
        },
        {
            pubkey: paymentAccount,
            isWritable: true,
            isSigner: false,
        },
        {
            pubkey: transferAuthority,
            isWritable: false,
            isSigner: false,
        },
        {
            pubkey: escrowPaymentAccount,
            isWritable: true,
            isSigner: false,
        },
        {
            pubkey: treasuryMint,
            isWritable: false,
            isSigner: false,
        },
        {
            pubkey: authority,
            isWritable: false,
            isSigner: false,
        },
        {
            pubkey: auctionHouse,
            isWritable: false,
            isSigner: false,
        },
        {
            pubkey: auctionHouseFeeAccount,
            isWritable: true,
            isSigner: false,
        },
        {
            pubkey: splToken.TOKEN_PROGRAM_ID,
            isWritable: false,
            isSigner: false,
        },
        {
            pubkey: web3.SystemProgram.programId,
            isWritable: false,
            isSigner: false,
        },
        {
            pubkey: web3.SYSVAR_RENT_PUBKEY,
            isWritable: false,
            isSigner: false,
        },
    ];
    const ix = new web3.TransactionInstruction({
        programId: new web3.PublicKey('hausS13jsjafwWwGqZTUQRmWyvyxn9EQpqMwV1PBBmk'),
        keys,
        data,
    });
    return ix;
}
exports.createDepositInstruction = createDepositInstruction;
//# sourceMappingURL=deposit.js.map